"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveStagedSiteSettingsMergeTagsChanges = exports.saveStagedSiteSettingsChanges = exports.SaveSiteSettingsChanges = exports.SaveSiteSettingsChangesActionTypes = exports.loadSiteSettings = exports.FetchSiteSettings = exports.FetchSiteSettingsActionTypes = exports.SiteSettingsActionTypes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _fluxActions = require("flux-actions");

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _constants = require("./constants");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var SlugConflictTypes = (0, _keyMirror.default)({
  PAGE_EXISTS: null,
  BLOG_EXISTS: null,
  REDIRECT_EXISTS: null,
  RESERVED_NAMESPACE: null
});
var SiteSettingsActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_SITE_SETTINGS: null,
  FETCH_SITE_SETTINGS: null,
  SAVE_SITE_SETTINGS_CHANGES: null,
  SAVE_SITE_SETTINGS_MERGE_TAG_CHANGES: null
}, 'shared');
exports.SiteSettingsActionTypes = SiteSettingsActionTypes;
var FetchSiteSettingsActionTypes = (0, _actions.createRequestTypes)(SiteSettingsActionTypes.FETCH_SITE_SETTINGS);
exports.FetchSiteSettingsActionTypes = FetchSiteSettingsActionTypes;
var FetchSiteSettings = (0, _actions.createRequestActions)(FetchSiteSettingsActionTypes);
exports.FetchSiteSettings = FetchSiteSettings;
var loadSiteSettings = (0, _fluxActions.createAction)(SiteSettingsActionTypes.LOAD_SITE_SETTINGS);
exports.loadSiteSettings = loadSiteSettings;
var SaveSiteSettingsChangesActionTypes = (0, _actions.createRequestTypes)(SiteSettingsActionTypes.SAVE_SITE_SETTINGS_CHANGES);
exports.SaveSiteSettingsChangesActionTypes = SaveSiteSettingsChangesActionTypes;
var SaveSiteSettingsChanges = (0, _actions.createRequestActions)(SaveSiteSettingsChangesActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SaveSiteSettingsChangesActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.pages.notifications.defaultMessage.success')));
  },
  failureMetaCreator: function failureMetaCreator(_ref) {
    var _ref$responseJSON = _ref.responseJSON,
        responseJSON = _ref$responseJSON === void 0 ? {} : _ref$responseJSON;
    var responseMessage = responseJSON.message,
        errorTokens = responseJSON.errorTokens,
        errorType = responseJSON.errorType;

    var defaultMessage = _I18n.default.text('marketing.pages.notifications.defaultMessage.error');

    var errorMessage;

    if (errorType in SlugConflictTypes) {
      var errorMessageOptions = {};

      switch (errorType) {
        case SlugConflictTypes.PAGE_EXISTS:
          {
            errorMessageOptions = {
              pageUrl: errorTokens.PAGE_URL[0]
            };
            break;
          }

        case SlugConflictTypes.BLOG_EXISTS:
          {
            errorMessageOptions = {
              blogUrl: errorTokens.BLOG_URL[0]
            };
            break;
          }

        case SlugConflictTypes.REDIRECT_EXISTS:
          {
            errorMessageOptions = {
              redirectSource: errorTokens.REDIRECT_SOURCE[0]
            };
            break;
          }

        case SlugConflictTypes.RESERVED_NAMESPACE:
          {
            errorMessageOptions = {
              reservedNamespace: errorTokens.RESERVED_NAMESPACE[0]
            };
            break;
          }

        default:
          break;
      }

      errorMessage = _I18n.default.text("marketing.pages.notifications.slugConflict." + errorType, errorMessageOptions);
    } else {
      errorMessage = responseMessage || defaultMessage;
    }

    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SaveSiteSettingsChangesActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(errorMessage));
  }
});
exports.SaveSiteSettingsChanges = SaveSiteSettingsChanges;
var saveStagedSiteSettingsChanges = (0, _fluxActions.createAction)(SiteSettingsActionTypes.SAVE_SITE_SETTINGS_CHANGES, function (options, _ref2) {
  var selectedDomain = _ref2.selectedDomain;
  var updatedSettings = options;

  if (selectedDomain !== _constants.ALL_DOMAINS_KEY) {
    updatedSettings = {
      bodyOverrideByDomain: (0, _defineProperty2.default)({}, selectedDomain, options)
    };
  }

  return {
    data: updatedSettings
  };
});
exports.saveStagedSiteSettingsChanges = saveStagedSiteSettingsChanges;
var saveStagedSiteSettingsMergeTagsChanges = (0, _fluxActions.createAction)(SiteSettingsActionTypes.SAVE_SITE_SETTINGS_MERGE_TAG_CHANGES, function (data) {
  return {
    data: data
  };
});
exports.saveStagedSiteSettingsMergeTagsChanges = saveStagedSiteSettingsMergeTagsChanges;